module.exports = __webpack_public_path__ + "img/official.267adbeb.jpg";